import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const RecipeService = {
  // Define your API functions here
  getList: async () => {
    const response = await apiService.get("/productrecipemain");
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/productrecipemain", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/productrecipemain/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/productrecipemain/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/productrecipemain/${id}`);
    return response.data;
  },
};

export default RecipeService;
